import * as React from 'react';
import AppRouter from './AppRouter';

export default function Router() {

	return <AppRouter />;
}
